/**
 * PAPPO — LoginPage
 * Página de login com card centralizado, fundo gradiente premium.
 * Email + Password. Links para criar conta e esqueci senha.
 */

import { useState, type FormEvent } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { Mail, Lock } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { Button } from '../components/common/Button';
import { Input } from '../components/common/Input';
import styles from './LoginPage.module.css';

export function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Redirecionar se já autenticado
  if (isAuthenticated) {
    return <Navigate to="/chat" replace />;
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email.trim() || !password) {
      setError('Preencha todos os campos');
      return;
    }

    setIsLoading(true);
    const result = await login({ email: email.trim(), password });
    setIsLoading(false);

    if (result.success) {
      navigate('/chat', { replace: true });
    } else {
      setError(result.error ?? 'Email ou senha incorretos');
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Logo */}
        <div className={styles.logo}>
          <img src="/pappo-logo.png" alt="Pappo" className={styles.logoIcon} />
          <p className={styles.subtitle}>Não fique de papo por aí, fique por aqui!</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className={styles.form}>
          {error && (
            <div className={styles.error} role="alert">
              {error}
            </div>
          )}

          <Input
            label="Email ou nome de utilizador"
            type="text"
            placeholder="seu@email.com ou utilizador"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            leftIcon={<Mail size={16} />}
            autoComplete="username"
          />

          <Input
            label="Senha"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            leftIcon={<Lock size={16} />}
            autoComplete="current-password"
          />

          <Button type="submit" fullWidth isLoading={isLoading} size="lg">
            Entrar
          </Button>
        </form>

        {/* Links — o cadastro vive SÓ na página de convite (A2) */}
        <div className={styles.links}>
          <Link to="/forgot-password" className={styles.link}>
            Esqueci a senha
          </Link>
        </div>
      </div>
    </div>
  );
}
